import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.delay = options.delay || 10000;
        this.currentId = -1;
        this.$dom = {};

        this.init();
    }

    /**
     * Initialisation.
     *
     */
    init() {
        // dom elements
        this.$dom.background = this.$el.find('.js-carousel-background');
        this.$dom.content = this.$el.find('.js-carousel-content');
        this.$dom.label = this.$el.find('.js-carousel-label');
        this.$dom.category = this.$el.find('.js-carousel-category');

        // initialiser les événements
        this.initEvent();

        // initialiser le carousel
        this.nextContent();

        // on execute le script toute les `this.delay` secondes
        // pour faire tourner le carousel (uniquement si plus d'1 contenu)
        if (this.$dom.background.length > 1) {
            this.setinterval = setInterval(() => {
                this.nextContent();
            }, this.delay);
        }
    }

    /**
     * Initialisation des événements.
     *
     */
    initEvent() {
        this.$el.on('click.Carousel', '.js-carousel-category', event => {
            event.preventDefault();

            // on arrête le loop du carousel
            if (this.$dom.background.length > 1) {
                clearInterval(this.setinterval);
            }

            // mettre à jour l'affichage
            this.currentId = $(event.target).index();
            this.updateDisplay();
        });
    }

    /**
     * Afficher le contenu suivant du carousel.
     *
     */
    nextContent() {
        this.currentId = (this.currentId + 1 >= this.$dom.category.length) ? 0 : this.currentId + 1;
        this.updateDisplay();
    }

    /**
     * Mettre à jour l'affichage du carousel.
     *
     */
    updateDisplay() {
        this.updateBackground();
        this.updateContent();
        this.updateLabel();
        this.updateCategory();
    }

    /**
     * Mettre à jour l'image du carousel, en fonction de l'id actif.
     *
     */
    updateBackground() {
        this.$dom.background.not(this.$dom.background.eq(this.currentId)).removeClass('is-current');
        this.$dom.background.eq(this.currentId).addClass('is-current');
    }

    /**
     * Mettre à jour le contenu du carousel, en fonction de l'id actif.
     *
     */
    updateContent() {
        this.$dom.content.not(this.$dom.content.eq(this.currentId)).removeClass('is-current');
        this.$dom.content.eq(this.currentId).addClass('is-current');
    }

    /**
     * Mettre à jour le label du carousel, en fonction de l'id actif.
     *
     */
    updateLabel() {
        this.$dom.label.not(this.$dom.label.eq(this.currentId)).removeClass('is-current');
        this.$dom.label.eq(this.currentId).addClass('is-current');
    }

    /**
     * Mettre à jour la catégorie du carousel, en fonction de l'id actif.
     *
     */
    updateCategory() {
        this.$dom.category.not(this.$dom.category.eq(this.currentId)).removeClass('is-current');
        this.$dom.category.eq(this.currentId).addClass('is-current');
    }

    destroy() {
        if (this.$dom.background.length > 1) {
            clearInterval(this.setinterval);
        }

        this.$el.off('.Carousel');

        this.delay = null;
        this.currentId = -1;
        this.$dom = {};
    }
}
